var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 position-relative d-flex flex-column root"},[_c('Header'),_c('div',{staticClass:"app-content flex-grow-1"},[_c('router-view')],1),_c('Footer'),_c('cookie-banner',{staticClass:"root__cookie-banner"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }